<template>
  <headerTop />
  <cookiesModal />
  <getConsultation />
  <v-main>
    <PartnerName :Partner="getPartner" />
    <PartnerDetails :Partner="getPartner" />
    <PartnerRealEstate :Partner="getPartner" :Cards="getRealEstateByAgent.filter(p => !p.is_archived)" class="mt-6" />
    <realEstateWorld class="mt-200" />
  </v-main>
  <footerComponent />
  <!-- <Preloader :is-loading="isLoading" /> -->
</template>

<script>
import footerComponent from "../components/footer.vue";
import headerTop from "../components/header.vue";
import cookiesModal from "../components/cookiesModal.vue";
/* import Preloader from "../components/Preloader.vue"; */
import PartnerName from "../components/PartnerSingle/1.PartnerName.vue";
import PartnerDetails from "../components/PartnerSingle/2.PartnerDetails.vue";
import PartnerRealEstate from "../components/PartnerSingle/3.PartnerRealEstate.vue";
import realEstateWorld from "../components/realEstateWorld.vue";
import getConsultation from "../components/getConsultation.vue";
import { defineComponent } from "vue";
import { mapGetters } from 'vuex'

export default defineComponent({
  name: "PartnerSingle",
  components: {
    headerTop,
    cookiesModal,
    /* Preloader, */
    getConsultation,
    PartnerName,
    PartnerDetails,
    PartnerRealEstate,
    realEstateWorld,
    footerComponent,
  },
  data: () => ({
    /* isLoading: true, */
  }),
  async mounted() {
    let allAgent = await this.$store.dispatch('LoadAllPartners');
    let vue = this;
    let agent = allAgent.filter((a) => {
      return a[`name_ro`] == vue.$route.params.name;
    });
    if (agent.length == 0) {
      this.$router.push({
        name: "partners",
        params: {
          lang: this.$vuetify.locale.current
        }
      })
      return
    }
    await this.$store.dispatch('LoadPartner', agent[0].ID);
    await this.$store.dispatch('LoadRealEstateByAgent', this.$route.params.name);

    /* if (document.readyState == "complete") {
      vue.isLoading = false;
    } else {
      window.addEventListener("load", () => {
        vue.isLoading = false;
      });
    } */
  },
  computed: {
    ...mapGetters([
      'getAllPartners',
      'getPartner',
      'getRealEstateByAgent',
    ])
  }
});
</script>
<style scoped>
.mt-200 {
  margin-top: 200px;
}

.mt-100 {
  margin-top: 100px;
}

@media screen and (max-width: 768px) {
  .mt-200 {
    margin-top: 80px;
  }
}
</style>